module.exports = __webpack_public_path__ + "static/Pink_v1-3ccda1e62f38ab67c3f1a50cf53975c9.gif";